import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoggedUser } from 'src/app/services/authentication/authentication';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ManagementTypesEnum } from 'src/app/services/rest-api/rest-api';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'libero-static-page-footer',
  templateUrl: './static-page-footer.component.html',
  styleUrls: ['./static-page-footer.component.scss'],
  standalone: false
})
export class StaticPageFooterComponent implements OnInit {
  public hideButtons = false;
  public disableInvestmentCreation = false;

  public get loggedUser(): LoggedUser {
    if(!this.userService.loggedUser || this.userService.loggedUser === null) {
      this.router.navigate(['/login']);
    }

    return this.userService.loggedUser!;
  }

  public constructor(
    private modalService: ModalService,
    public userService: UserService,
    private router: Router,
  ) { }

  public ngOnInit(): void {
    if(
      (this.router.url === '/own-strategies' || this.router.url === '/thematic-portfolios') &&
      this.loggedUser.managementType !== ManagementTypesEnum.EXECUTION_ONLY
    ) {
      this.hideButtons = true;
    }

    this.disableInvestmentCreation = !(this.loggedUser.validContracts.filter(contract => !contract.inLiquidation).length > 0);
  }

  public openModal(): void {
    this.modalService.openConsultModal();
  }
}
